import "swiper/swiper.min.css";
import "swiper/modules/pagination/pagination.min.css";

import { gql, useQuery } from "@apollo/client";
import {
  IonButton,
  IonButtons,
  IonChip,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonIcon,
  IonPage,
  IonRouterLink,
  IonRow,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { chevronBackOutline, downloadOutline } from "ionicons/icons";
import { useHistory, useParams } from "react-router";
import { Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react/swiper-react";

import {
  OutfitCard,
  OutfitCardData,
  OutfitCardFragment,
} from "../../components/OutfitCard";

export const ExploreCapsulePage: React.FC = () => {
  const history = useHistory();

  const { capsuleId } = useParams<{ capsuleId: string }>();

  const query = useQuery<{ publicCapsules: Capsule[] }>(GET_CAPSULE, {
    variables: { capsuleId },
  });

  const capsule = query.data?.publicCapsules?.[0];
  if (!capsule) return null;

  const uniqueItemIds = Array.from(
    new Set(capsule.outfits.map((o) => o.items.map((x) => x.id)).flat())
  );

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonButton routerLink="/main/explore">
              <IonIcon icon={chevronBackOutline} />
              Back
            </IonButton>
          </IonButtons>
          <IonTitle>{capsule.title}</IonTitle>
          <IonButtons slot="end">
            <IonButton
              routerLink={`/main/explore/capsules/${capsule.id}/import`}
            >
              Import <IonIcon icon={downloadOutline} slot="end" />
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonGrid
          style={{ height: "100%", display: "flex", flexDirection: "column" }}
        >
          <IonRow>
            <IonCol
              style={{
                display: "flex",
                justifyContent: "space-between",
                paddingLeft: 8,
                paddingRight: 8,
              }}
            >
              <div>
                {capsule.tags.map((tag) => (
                  <IonChip key={tag} outline>
                    {tag}
                  </IonChip>
                ))}
              </div>
            </IonCol>
          </IonRow>

          <IonRow style={{ flex: 2 }}>
            <IonCol>
              <Swiper
                spaceBetween={50}
                slidesPerView={1}
                pagination={{ dynamicBullets: true, el: ".swiper-pagination" }}
                modules={[Pagination]}
                style={{ overflow: "visible" }}
              >
                {capsule.outfits.map((outfit) => (
                  <SwiperSlide key={outfit.id}>
                    <OutfitCard outfit={outfit} large />
                  </SwiperSlide>
                ))}
                <div
                  className="swiper-pagination"
                  slot="pagination"
                  style={{ bottom: -20 }}
                />
              </Swiper>
            </IonCol>
          </IonRow>

          <IonRow style={{ flex: 1 }}>
            <IonCol>
              <h1>
                Capsule details: <br />
                {capsule.outfits.length} outfits <br />
                <IonRouterLink
                  onClick={() =>
                    history.push(`/main/explore/capsules/${capsuleId}/items`)
                  }
                >
                  {uniqueItemIds.length} items{" "}
                </IonRouterLink>{" "}
              </h1>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  );
};

export const CapsulePageFragment = gql`
  fragment CapsulePage on Capsule {
    id
    title
    tags
    isPublic
    outfits {
      id
      items {
        id
      }
      ...OutfitCard
    }
  }
  ${OutfitCardFragment}
`;

export const GET_CAPSULE = gql`
  query CapsulePageQuery($capsuleId: ID!) {
    publicCapsules(capsuleIds: [$capsuleId]) {
      ...CapsulePage
    }
  }
  ${CapsulePageFragment}
`;
export interface Capsule {
  id: string;
  title: string;
  tags: string[];
  isPublic: boolean;
  outfits: OutfitCardData[];
}
